import React from "react";

import { colors } from "components";

import { BaseCard } from "components/BaseCard";
import { CircleIcon } from "components/CircleIcon";
import { CircularButton } from "components/CircularButton";
import { TitleSubTitleLabel } from "components/TitleSubTitleLabel";

import { IAttendantCard } from "./interface";
import {
  AttendantCardTopContainer,
  ButtonContainer,
  Container,
  ContainerIcon,
  IconArea,
  LeftContainer,
  RightContainer,
} from "./styles";

export const AttendantCard: React.FC<IAttendantCard> = ({
  id,
  subTitle,
  title,
  selected,
  icon,
  onClickItem,
  setSelectAttendant,
  onClickCopy,
  item,
  disabled,
  disabledDesfix,
  disabledCopy,
}) => {
  return (
    <>
      <AttendantCardTopContainer>
        <BaseCard
          selected={selected}
          onClick={onClickItem}
          data-testid={id}
          fixedBorder={true}
          disabled={disabled}
        >
          <Container>
            <LeftContainer>
              <ContainerIcon>
                <IconArea>
                  {icon === "avatar" ? (
                    <CircleIcon
                      icon={icon}
                      borderColor={colors.primary_default}
                      colorIcon={colors.general_icons}
                      backgroundColor="none"
                    />
                  ) : (
                    <CircleIcon
                      icon={icon}
                      borderColor={colors.secundary_default}
                      colorIcon={colors.secundary_default}
                      backgroundColor="none"
                    />
                  )}
                </IconArea>
              </ContainerIcon>
              <TitleSubTitleLabel
                childrenTitle={title}
                childrenSubTitle={subTitle}
                marginTop="0px"
              />
            </LeftContainer>
            <RightContainer id="buttonsRight">
              <ButtonContainer>
                <CircularButton
                  icon="copy"
                  data-testid="copy-button"
                  onClick={() =>
                    item && onClickCopy ? onClickCopy(item) : null
                  }
                  colorIcon={colors.neutral_white}
                  border={`2px solid ${colors.primary_default}`}
                  backgroundColor={colors.primary_default}
                  disabled={disabled || disabledCopy}
                />

                <CircularButton
                  icon="desfix"
                  data-testid="desfix-button"
                  onClick={() => setSelectAttendant(item.id)}
                  colorIcon={colors.neutral_white}
                  border={`2px solid ${colors.primary_default}`}
                  backgroundColor={colors.primary_default}
                  disabled={disabled || disabledDesfix}
                />
              </ButtonContainer>
            </RightContainer>
          </Container>
        </BaseCard>
      </AttendantCardTopContainer>
    </>
  );
};
